import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import IconButton from "@mui/material/IconButton";
import { CustomLink } from "core/components/CustomLink";
import { pickHighlight, renderHighlight } from "core/components/HighlightText";
import { useFormatDate } from "core/hooks/useFormatDate";
import { MyLinksIcon } from "features/MyLinks/components/MyLinksIcon";
import { getMyLinksHref } from "features/MyLinks/utils";
import { useTranslation } from "react-i18next";
import type { SearchResultNews } from "../defs";
import { SearchItemTemplate } from "./SearchItemTemplate";

export function SearchItemNews(props: SearchResultNews) {
  const { t } = useTranslation("Fixhub", { keyPrefix: "Next:Core:SearchItem" });
  const {
    aggregateRootId,
    dynamicData,
    blurb,
    title,
    isFavorited,
    highlights,
  } = props;
  const formatDate = useFormatDate();
  return (
    <SearchItemTemplate
      data-testid="search-item-news"
      dateLabel={t("publishedTime")}
      dateText={formatDate(dynamicData.publishedTime)}
      secondaryAction={
        <IconButton
          LinkComponent={CustomLink}
          disabled={!aggregateRootId}
          href={getMyLinksHref("News", aggregateRootId)}
        >
          <KeyboardDoubleArrowRight color="primary" />
        </IconButton>
      }
      AvatarIcon={<MyLinksIcon itemType="News" />}
      title={renderHighlight(title, pickHighlight(highlights, "String1"))}
      middleSlot={renderHighlight(blurb, pickHighlight(highlights, "String5"))}
      isFavorited={isFavorited}
    />
  );
}
